export default __webpack_public_path__ + "static/grouping-dont-38bbf683c2c485a332eabea97b60e560.png";